var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propNumber } from '../../../helpers/custom-prop-types';
import { CurrentProcessLoader } from '../../Ui/Loading';
/**
 * 読み込み中かどうかの表示切り替えを行うHOC
 * @returns {function(*): Function}
 * @constructor
 */
const IsLoadingHoc = (ChildComponent) => {
    const IsLoadingHocInner = (props) => {
        const { isLoading, isLoadingMarginBottom, isLoadingMarginTop } = props, childProps = __rest(props, ["isLoading", "isLoadingMarginBottom", "isLoadingMarginTop"]);
        if (isLoading) {
            return (_jsx(CurrentProcessLoader, { marginBottom: isLoadingMarginBottom || 0, marginTop: isLoadingMarginTop || 0 }));
        }
        return _jsx(ChildComponent, Object.assign({}, childProps));
    };
    IsLoadingHocInner.propTypes = {
        isLoading: propBool().isRequired,
        isLoadingMarginBottom: propNumber(),
        isLoadingMarginTop: propNumber(),
    };
    IsLoadingHocInner.defaultProps = {
        isLoadingMarginBottom: 0,
        isLoadingMarginTop: 0,
    };
    return IsLoadingHocInner;
};
export default IsLoadingHoc;
